import { PageHeader } from "@/components/PageHeader";
import { Studio } from "@/components/Studio";
import { Craft } from "@/components/Craft";
import { DesignLanguage } from "@/components/DesignLanguage";
import { Engineering } from "@/components/Engineering";

export default function StudioPage() {
    return (
        <div data-testid="page-studio">
            <PageHeader
                number="S"
                label="The Studio"
                title="Architects & Engineers,"
                accent="Designing for Living."
                text="Who we are, what we believe, and the design language we bring to every home and workplace in Kolkata."
                testid="studio-page-header"
            />
            <Studio />
            <Craft />
            <DesignLanguage />
            <Engineering />
        </div>
    );
}
